import { render, staticRenderFns } from "./Singleimage.vue?vue&type=template&id=2783fd78&scoped=true"
import script from "./Singleimage.vue?vue&type=script&lang=js"
export * from "./Singleimage.vue?vue&type=script&lang=js"
import style0 from "./Singleimage.vue?vue&type=style&index=0&id=2783fd78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783fd78",
  null
  
)

export default component.exports